import React from "react";
import "./Footer.css";

function Footer() {
  return (
    <footer className="footer">
      <div className="footer-container">
        {/* İletişim Bilgileri */}
        <div className="contact-info">
          <h4>İletişim Bilgileri</h4>
          <h4>
            Şanlıurfa Ticaret ve Sanayi Odası <br /> Gıda Araştırma ve Analiz Merkezi A. Ş.
          </h4>
          <p>📞 Telefon: 0414 318 18 00/6365 - 0539 614 86 01</p>
          <p>📍 Adres: Koçören OSB Mah. 105. Cad. No:34/1 Eyyübiye/Şanlıurfa</p>
          <p>✉️ E-Posta: info@sutsogaam.org</p>
        </div>

        {/* Harita */}
        <div className="map-container">
          <iframe
            src="https://www.google.com/maps/embed?pb=!1m17!1m12!1m3!1d3181.8494278784674!2d38.64631787585242!3d37.10870157216074!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m2!1m1!2zMzfCsDA2JzMxLjMiTiAzOMKwMzgnNTYuMCJF!5e0!3m2!1str!2str!4v1731924163063!5m2!1str!2str"
            width="100%"
            height="250"
            style={{ border: "0", borderRadius: "10px" }}
            allowFullScreen=""
            loading="lazy"
            title="Konum Haritası"
          ></iframe>
        </div>
        {/* Sosyal Medya Bağlantıları */}
        <div className="social-media">
          <h4>Sosyal Medya</h4>
          <div className="social-media-icons">
            <a href="https://x.com/sutsogaam" target="_blank" rel="noopener noreferrer">
              <i className="fab fa-x-twitter"></i> {/* X (eski Twitter) */}
            </a>
            <a
              href="https://www.instagram.com/sutsogaam"
              target="_blank"
              rel="noopener noreferrer"
            >
              <i className="fab fa-instagram"></i> {/* Instagram */}
            </a>
            <a
              href="https://www.linkedin.com/in/%C5%9Fanl%C4%B1urfa-ticaret-ve-sanayi-odas%C4%B1-g%C4%B1da-ara%C5%9Ft%C4%B1rma-ve-analiz-merkezi-1894b3246/"
              target="_blank"
              rel="noopener noreferrer"
            >
              <i className="fab fa-linkedin"></i> {/* LinkedIn */}
            </a>
          </div>
        </div>
      </div>

        {/* Faydalı Linkler */}
        <div className="useful-links">
          <h4>Faydalı Linkler</h4>
          <div className="useful-links-container">
            <a
              href="https://www.sutso.org.tr"
              target="_blank"
              rel="noopener noreferrer"
              className="useful-link"
            >
              <img
                src="/images/sutsologo.jpeg" // Faydalı link logosu
                alt="SUTSO"
                className="useful-link-logo"
              />
            </a>
          </div>
        </div>

    </footer>
  );
}

export default Footer;
